import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const FormUnderlineContainer = styled(Link)`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette?.brand.secondary.base}
`;
